import { render, staticRenderFns } from "./RankingAthletes.vue?vue&type=template&id=2a883e92&"
import script from "./RankingAthletes.vue?vue&type=script&lang=js&"
export * from "./RankingAthletes.vue?vue&type=script&lang=js&"
import style0 from "./RankingAthletes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports